(function () {
  'use strict';

  function initMarquee(root) {
    if (!root || root.dataset.awxReady === '1') return;

    var viewport = root.querySelector('.awx-marquee__viewport');
    var track = root.querySelector('.awx-marquee__track');
    var original = root.querySelector('[data-awx-original]');
    if (!viewport || !track || !original) return;

    root.dataset.awxReady = '1';

    var dir = root.dataset.direction === 'ltr' ? -1 : 1;
    var duration = parseFloat(root.dataset.duration) || 40;

    var offset = 0;
    var setWidth = 0;
    var pxPerSec = 0;
    var velocity = 0;
    var dragging = false;
    var hovered = false;
    var moved = 0;
    var lastX = 0;
    var lastTime = null;

    function measure() {
      var w = original.getBoundingClientRect().width;
      if (w > 0) return w;
      var total = 0;
      var kids = original.children;
      for (var i = 0; i < kids.length; i++) {
        total += kids[i].getBoundingClientRect().width;
      }
      return total;
    }

    function build() {
      var w = measure();
      if (!w) return;

      setWidth = w;
      pxPerSec = w / duration;

      var vw = viewport.getBoundingClientRect().width || w;
      var need = Math.ceil(vw / w) + 2;
      if (need < 3) need = 3;

      var clones = track.querySelectorAll('.awx-marquee__set:not([data-awx-original])');
      if (clones.length === need - 1) return;

      for (var i = 0; i < clones.length; i++) clones[i].remove();

      var frag = document.createDocumentFragment();
      for (var j = 1; j < need; j++) {
        var c = original.cloneNode(true);
        c.removeAttribute('data-awx-original');
        c.setAttribute('aria-hidden', 'true');
        var eb = c.querySelectorAll('[data-shopify-editor-block]');
        for (var k = 0; k < eb.length; k++) {
          eb[k].removeAttribute('data-shopify-editor-block');
        }
        frag.appendChild(c);
      }
      track.appendChild(frag);
    }

    function clearActive() {
      var actives = root.querySelectorAll('.awx-marquee__item.is-active');
      for (var i = 0; i < actives.length; i++) {
        actives[i].classList.remove('is-active');
      }
    }

    /* Hover / touch korle carousel PAUSE hobe */
    root.addEventListener('mouseenter', function () { hovered = true; });
    root.addEventListener('mouseleave', function () { hovered = false; });
    root.addEventListener('touchstart', function () { hovered = true; }, { passive: true });
    root.addEventListener('touchend', function () {
      setTimeout(function () {
        /* Kono image active (icon dekhano) thakle carousel thama e thakbe */
        if (!root.querySelector('.awx-marquee__item.is-active')) {
          hovered = false;
        }
      }, 700);
    }, { passive: true });

    /* Drag — icon er upor pointer dile drag hobe na, link free thakbe */
    viewport.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      if (e.target.closest && e.target.closest('.awx-marquee__icon')) return;
      dragging = true;
      moved = 0;
      lastX = e.clientX;
      velocity = 0;
      root.classList.add('is-dragging');
      try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      moved += Math.abs(dx);
      offset += dx;
      velocity = dx * 55;
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      try { viewport.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* Click: drag hole cancel; image e tap hole icon toggle */
    viewport.addEventListener('click', function (e) {
      if (moved > 6) {
        e.preventDefault();
        e.stopPropagation();
        moved = 0;
        return;
      }
      moved = 0;

      /* Icon e click — kichu koro na, link nije khulbe */
      if (e.target.closest && e.target.closest('.awx-marquee__icon')) return;

      /* Image e tap — oi image er icon show/hide toggle */
      var item = e.target.closest ? e.target.closest('.awx-marquee__item') : null;
      if (!item) {
        clearActive();
        hovered = false;
        return;
      }

      var wasActive = item.classList.contains('is-active');
      clearActive();
      if (!wasActive && item.querySelector('.awx-marquee__overlay')) {
        item.classList.add('is-active');
        hovered = true; /* icon dekhano obosthay carousel thama thakbe */
      } else {
        hovered = false;
      }
    }, true);

    /* Carousel er baire tap korle icon lukiye jabe */
    document.addEventListener('click', function (e) {
      if (root.contains(e.target)) return;
      if (root.querySelector('.awx-marquee__item.is-active')) {
        clearActive();
        hovered = false;
      }
    });

    /* Animation loop */
    function tick(now) {
      if (lastTime === null) lastTime = now;
      var dt = Math.min((now - lastTime) / 1000, 0.05);
      lastTime = now;

      if (setWidth > 0) {
        if (!dragging) {
          if (!hovered) {
            offset -= pxPerSec * dt * dir;
          }
          if (Math.abs(velocity) > 2) {
            offset += velocity * dt;
            velocity *= 0.93;
          } else {
            velocity = 0;
          }
        }

        while (offset <= -setWidth) offset += setWidth;
        while (offset > 0) offset -= setWidth;

        track.style.transform = 'translate3d(' + offset + 'px,0,0)';
      } else {
        build();
      }

      requestAnimationFrame(tick);
    }

    /* Resize / image load hole abar measure */
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(build);
      ro.observe(original);
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', build);
    }

    var imgs = original.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) {
        imgs[i].addEventListener('load', build, { once: true });
      }
    }
    window.addEventListener('load', build);

    build();
    requestAnimationFrame(tick);
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-awx-marquee]');
    for (var i = 0; i < sections.length; i++) {
      initMarquee(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();